(() => {
  const end = Date.parse('2026-10-10T00:00:00-03:00');
  const expire = () => {
    if (Date.now() < end) return;
    document.querySelectorAll('[data-clio-cyber-banner]').forEach(el => el.remove());
    document.querySelectorAll('[data-clio-cyber-label]').forEach(el => {
      el.textContent = el.dataset.regularLabel;
      el.removeAttribute('data-clio-cyber-label');
    });
  };
  expire();
  const remaining = end - Date.now();
  if (remaining > 0) setTimeout(expire, remaining);
})();
